import { useFormikContext } from 'formik';
import { Col, Form, Row } from 'react-bootstrap';
import FormLabel from '../../../Text/FormLabel';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import ReactTextEditor from '../../../Editors/ReactTextEditor';
import StatusCheck from '../../StatusCheck';
import ReactDatePicker from '../../../ReactDatePicker/ReactDatePicker';
import useFetch from '../../../../hooks/useFetch';
import request from '../../../../request/request';
import ReactMultiSelect from '../../../ReactSelect/ReactMultiSelect';

const BlogForms = () => {
    const { values, setFieldValue } = useFormikContext();
    const { result } = useFetch(() => request.getAll('blog-category/getData/active'));

    // console.log(values);

    return (
        <Row>
            <Col sm={12} md={6}>
                <Form.Group className='mt-3'>
                    <FormLabel title='Title' required />
                    <ReactInput name='title' />
                </Form.Group>
            </Col>

            <Col sm={12} md={6}>
                <Form.Group className='mt-3'>
                    <FormLabel title='Blog Category' required />
                    <ReactMultiSelect
                        data={result}
                        labelName='title'
                        valueName='id'
                        value={values?.blog_cat}
                        defaultValue={values?.blog_cat}
                        onChange={(val) =>
                            setFieldValue(
                                'blog_cat',
                                val?.map((item) => item)
                            )
                        }
                        // onChange={(val) => console.log(val)}
                        isMulti
                    />
                </Form.Group>
            </Col>

            <Col sm={12} md={6}>
                <Form.Group className='mt-3'>
                    <FormLabel title='Date' required />
                    <ReactDatePicker
                        value={values?.blog_date}
                        onChange={(val) => setFieldValue('blog_date', val)}
                    />
                </Form.Group>
            </Col>

            <Col sm={12} md={6}>
                <Form.Group className='mt-3'>
                    <FormLabel title='Blog Image' required />
                    <ReactInput name='blog_img' type='file' />
                </Form.Group>
            </Col>

            <Col sm={12} md={6}>
                <Form.Group className='mt-3'>
                    <FormLabel title='Short Description' required />
                    <ReactInput name='short_description' as='textarea' row={3} />
                </Form.Group>
            </Col>

            <Col sm={12}>
                <Form.Group className='mt-3'>
                    <FormLabel title='Long Description' required />
                    <ReactTextEditor
                        defaultData={values?.long_description}
                        setEditorData={(val) => setFieldValue('long_description', val)}
                    />
                </Form.Group>
            </Col>

            <div>
                <StatusCheck />
            </div>
        </Row>
    );
};

export default BlogForms;
